// Contact form block schema - Let visitors send messages
export const contactSchema = {
  type: 'contact',
  label: 'Contact Form',
  description: 'Let visitors send you messages',
  icon: 'MessageSquare',
  defaultContent: {
    heading: 'Get in Touch',
    description: '',
    showNameField: true,
    showSubscribeOption: true,
    style: {},
  },
  fields: [
    { name: 'heading', label: 'Heading', type: 'text', placeholder: 'Get in Touch' },
    { name: 'description', label: 'Description', type: 'textarea' },
  ],
};
